import React from "react";
import HTMLFlipBook from "react-pageflip";
import "./bookFlip.css";

export default function BookPageFlip({ pages }) {
  return (
    <div className="book cursor-grab overflow-hidden"> 
      <div className="flipbookContainer overflow-hidden">
        <HTMLFlipBook
          width={210}   // à ajuster si besoin
          height={340}  // à ajuster si besoin
          style={{ transition: "all 0s ease" }}
          drawShadow={false}
          showCover={false}
        >
          {pages.map((page, index) => (
            <div
              key={index}
              className={`demoPage ${index % 2 === 0 ? "left" : "right"}`}
            >
              <div className="text-container">
                {/* Titre */}
                {page.type === "cover" ? (
                  <div className="page-title">{page.title}</div>
                ) : (
                  <>
                    <div className="page-title">{page.title}</div>
                    <div className="page-body">
                      {page.body.split("\n").map((line, i) => (
                        <p key={i}>{line}</p>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}
        </HTMLFlipBook>
      </div>
    </div>
  );
}